import { Injectable } from '@angular/core';
import {
  DEFAULT_LANGUAGE,
  Language,
  changeLanguage,
} from '@thiememeulenhoff/translations';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  readonly #currentLanguage = new BehaviorSubject<Language>(DEFAULT_LANGUAGE);

  /**
   * Emits the current language whenever it changes.
   */
  public readonly currentLanguage$ = this.#currentLanguage.asObservable();

  /**
   * Returns the current language.
   */
  get currentLanguage(): Language {
    return this.#currentLanguage.value;
  }

  /**
   * Changes the current language.
   *
   * @param language The language to change to.
   */
  changeLanguage(language: Language): void {
    changeLanguage(language);
    this.#currentLanguage.next(language);

    document.documentElement.lang = language;
  }
}
